import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Improvisar el protocolo en cada sesión',
    cost: 'Inseguridad clínica que el paciente percibe'
  }, {
    without: 'Sin algoritmo de diagnóstico',
    cost: 'Confusión que frena los resultados'
  }, {
    without: 'Sin versión de digitopuntura',
    cost: 'Perdés pacientes que no toleran las agujas'
  }, {
    without: 'Sin protocolo de crisis',
    cost: 'Quedás expuesto ante una emergencia en sesión'
  }, {
    without: 'Sin plan alimentario ni guía de hierbas',
    cost: 'El paciente boicotea el tratamiento sin saberlo'
  }, {
    without: 'Sin ficha del paciente',
    cost: 'Cada consulta sin registro ni continuidad'
  }, {
    without: 'Sin Maestría en Consulta',
    cost: 'Seguís esperando que los pacientes vuelvan solos'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de inseguridad, la próxima semana'
  }];
  return <Section data-id="element-17">
      <div className="text-center mb-12" data-id="element-18">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-greenDark" data-id="element-19">
          <span className="mr-3" data-id="element-20">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-21">
        <div className="hidden md:block" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-23">
            <div className="font-serif font-bold text-lg text-brand-green" data-id="element-24">
              Sin Kit MTC
            </div>
            <div className="font-serif font-bold text-lg text-brand-cupping" data-id="element-25">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-26">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-cupping/10 bg-white/70" data-id="element-27">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-28">
                  {row.without}
                </div>
                <div className="text-sm text-brand-cupping/90 font-medium" data-id="element-29">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-30">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-cupping/10 bg-white/70 space-y-2" data-id="element-31">
              <p className="text-sm font-medium text-brand-text/90" data-id="element-32">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-cupping/90 font-medium" data-id="element-33">
                <span className="text-brand-cupping shrink-0" data-id="element-34">→</span>
                <span className="text-sm" data-id="element-35">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-36">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-[#052321]" data-id="element-37">
          "El terapeuta que tiene un sistema, aplica con confianza. El que
          aplica con confianza, genera resultados. El que genera resultados,
          crece." 🌿
        </p>
      </div>
    </Section>;
};